import { NameDto } from '../../Common/Types'
import { TickmillCompanyDto } from '../../Identity/Types/Company'
import {
  BonusCampaignAvailabilityPeriod,
  BonusCampaignCountdownTrigger,
  BonusCampaignExcludeType,
  BonusLabel,
} from './BonusCampaignTypes'

export interface BonusCampaignsDto {
  id: string
  name: string
  minDeposit: number
  maxBonus: number
  termsAndConditionsUrl: string
  startDate: string
  endDate: string
  bonusExpirationDate: string
  bonusType: {
    id: string
    name: string
  }
  bonusPercent: number
  bonusAmount: number
  bonusCampaignStatus: {
    id: number
    name: string
  }
  defaultCurrency: NameDto<string> | null
  campaignPaymentMethods: NameDto<string>[]
  tickmillCompanies: TickmillCompanyDto[]
  lastUpdatedDate: string
  noPreviousDeposits: boolean
  availableOnlyOnce: boolean
  minTotalTradedLots: number
  maxTotalPnl: number
  validDaysAfterActivation: number
  firstTradeRequirementFromDays: number | null
  targetOnlyInactiveClients: boolean
  bonusCampaignIntroducingBrokers: NameDto<string>[]
  bonusCampaignAffiliates: NameDto<string>[]
  bonusCampaignUtms: string[]
  internalName: string
  bonusLabel: BonusLabel
  bonusCampaignExcludeType: BonusCampaignExcludeType
  bonusCampaignAvailabilityPeriod: BonusCampaignAvailabilityPeriod

  value: number | null
  bonusCampaignCountdownTrigger: BonusCampaignCountdownTrigger | null
}

export interface AddCampaignDetailsFormValues {
  name: string
  minDeposit: number
  maxBonus: number
  termsAndConditionsUrl: string
  startDate: string
  endDate: string
  bonusExpirationDate: string
  bonusTypeId: string
  bonusPercent: number | null
  bonusAmount: number | null
  bonusCampaignStatusId: number
  defaultCurrencyId: string | null
  campaignPaymentMethods: NameDto<string>[]
  tickmillCompanyIds: number[]
  noPreviousDeposits?: boolean
  availableOnlyOnce?: boolean
  minTotalTradedLots?: number | null
  maxTotalPnl?: number | null
  validDaysAfterActivation?: number | null
  firstTradeRequirementFromDays?: number | null
  targetOnlyInactiveClients?: boolean
  bonusCampaignIntroducingBrokers: NameDto[]
  bonusCampaignAffiliates: NameDto[]
  bonusCampaignUtms: string[]
  internalName: string
  bonusLabelId: number | null
  bonusCampaignExcludeTypeId: number | null
  bonusCampaignAvailabilityPeriodId: number | null
  value: number | null
  bonusCampaignCountdownTriggerId: number | null
}

export interface EditCampaignDetailsFormValues {
  id: string
  name: string
  minDeposit: number
  maxBonus: number
  termsAndConditionsUrl: string
  startDate: string
  endDate: string
  bonusExpirationDate: string
  bonusTypeId: string
  bonusPercent: number | null
  bonusAmount: number
  bonusCampaignStatusId: number
  defaultCurrencyId: string | null
  campaignPaymentMethods: NameDto<string>[]
  tickmillCompanyIds: number[]
  noPreviousDeposits: boolean
  availableOnlyOnce: boolean
  minTotalTradedLots: number
  maxTotalPnl: number | null
  validDaysAfterActivation: number
  firstTradeRequirementFromDays: number | null
  targetOnlyInactiveClients: boolean
  bonusCampaignIntroducingBrokers: string[]
  bonusCampaignAffiliates: string[]
  bonusCampaignUtms: string[]
  internalName: string
  bonusLabelId: number
  bonusCampaignExcludeTypeId: number
  bonusCampaignAvailabilityPeriodId: number
  value: number | null
  bonusCampaignCountdownTriggerId: number | null
}

export type BonusCampaignDto = EditCampaignDetailsFormValues

export interface BonusCampaignCountryDto {
  bonusCampaignId: string
  bonusCampaignCountryOptionId: string
  countries: NameDto<string>[]
  tickmillCompany: {
    id: number
    name: string
  }
  minimumAmount: number
  isActive: boolean
}

export interface BonusCampaignCountryFormValues {
  countryIds: string[]
  tickmillCompanyId: number
  minimumAmount?: number
  isActive: boolean
}

export interface BonusCampaignCountryFormValuesEdit {
  bonusCampaignCountryOptionId: string
  countryIds: string[]
  tickmillCompanyId: number
  minimumAmount?: number
  isActive: boolean
}

export enum MarketingBonusCampaignKey {
  name = 'name',
  startDate = 'startDate',
  endDate = 'endDate',
  status = 'bonusCampaignStatus.name',
  lastUpdatedDate = 'lastUpdatedDate',
  internalName = 'internalName',
  bonusType = 'bonusType.name',
}

export const BonusCampaignStatus: NameDto[] = [
  { id: 0, name: 'Disabled' },
  { id: 1, name: 'Enabled' },
  { id: 2, name: 'Paused' },
]
